<template>
  <div class = "main-container-content-nonEmptyState">
    <div class = "nonEmptyStateGrowth mb-15" @click = "displayGrowth">
        <div class = "images-container">
            <img src = '/img/growthIcon-4f.svg' id = "growthImage">
            <p class = "referralLinkText">Growth</p>
        </div>
        <div class = "values-container">
            <p class = "growth-account-value">&#x20B9;{{growthAccountValue | localeAmountPaisa }}</p>
            <v-icon v-if = "!displayGrowthTrans" class="material-icons-round bannerIcons">
                navigate_next
            </v-icon>
            <v-icon v-else class="material-icons-round bannerIcons">
                expand_more
            </v-icon>
        </div>
    </div>
    <div v-if = "displayGrowthTrans" class = "mt-10 incomeWhole" id="incomeContainer" @scroll="loadMoreGrowth">
        <div v-for="(item, index) in growthTransactions" :key="index" class = "incomeTransContainer">
            <v-icon class="material-icons-round transactionIconsWithdrawal" v-if="item.type=='internalPortfolioWithdrawal'">
                north_west
            </v-icon>
            <v-icon class="material-icons-round transactionIcons" v-else>
                south_east
            </v-icon>
            <div class = "risk-container">
                <p class = "description"> {{item.description}} </p>
                <p class = "fundDate"> {{item.fundDate | customFormatDate}} </p>
            </div>
            <p class = "transactionAmount"> &#x20B9;{{item.amount | localeAmountPaisa}} </p>
        </div>
    </div>
    <div v-if="isLoadingGrowth" class = "loaderContainer mb-10">
            <v-progress-circular
                indeterminate
                color="#13285e"
            ></v-progress-circular>
    </div>
    <div class = "nonEmptyStateGrowth mb-15" @click = "displayIncome">
        <div class = "images-container">
            <v-icon class="material-icons-round bannerIcons mr-5">
                calendar_month
            </v-icon>
            <p class = "referralLinkText">Income</p>
        </div>
        <div class = "values-container">
            <p class = "growth-account-value">&#x20B9;{{incomeAccountValue | localeAmountPaisa}}</p>
            <v-icon v-if = "!displayIncomeTrans" class="material-icons-round bannerIcons">
                navigate_next
            </v-icon>
            <v-icon v-else class="material-icons-round bannerIcons">
                expand_more
            </v-icon>
        </div>
    </div>
    <div v-if = "displayIncomeTrans" class = "mt-10 incomeWhole" @scroll="loadMoreIncome">
        <div v-for="(item, index) in incomeTransactions" :key="index" class = "incomeTransContainer">
            <v-icon class="material-icons-round transactionIconsWithdrawal" v-if="item.type=='internalPortfolioWithdrawal'">
                north_west
            </v-icon>
            <v-icon class="material-icons-round transactionIcons" v-else>
                south_east
            </v-icon>
            <div class = "risk-container">
                <p class = "description"> {{item.description}} </p>
                <p class = "fundDate"> {{item.fundDate | customFormatDate}} </p>
            </div>
            <p class = "transactionAmount"> &#x20B9;{{item.amount | localeAmountPaisa}} </p>
        </div>
    </div>
    <div  v-if="isLoadingIncome" class = "loaderContainer mb-10">
            <v-progress-circular
            indeterminate
            color="#13285e"
            ></v-progress-circular>
    </div>
    <div class = "nonEmptyStateGrowth noCursor mb-15">
        <div class = "images-container">
            <v-icon class="material-icons-round bannerIcons mr-5">
                account_balance_wallet
            </v-icon>
            <p class = "referralLinkText">Escrow Balance</p>
        </div>
        <div class = "values-container">
            <p class = "escrow-value">&#x20B9;{{escrowBalance | localeAmount}}</p>
        </div>
    </div>
  </div>
</template>

<script>
import lenderService from '@/services/lenderService'
export default {
    props: {
        escrowBalance: Number
    },
    data () {
        return {
            scrolling: {
                scrollTop: null,
                clientHeight: null,
                scrollHeight: null
            },
            growthAccountValue: null,
            incomeAccountValue: null,
            displayIncomeTrans: false,
            displayGrowthTrans: false,
            incomeTransactions: [],
            incomeTotalRecords: null,
            incomePage: 1,
            incomeItemsPerPage: 5,
            growthTransactions: [],
            growthTotalRecords: null,
            growthPage: 1,
            growthItemsPerPage: 5,
            isLoadingGrowth: false,
            isLoadingIncome: false
        }
    },
    mounted () {
        this.getPortfolioData()
    },
    beforeDestroy () {
        this.growthAccountValue = null
        this.incomeAccountValue = null
        this.displayIncomeTrans = false
        this.displayGrowthTrans = false
        this.incomeTransactions = []
        this.incomeTotalRecords = null
        this.incomePage = 1
        this.incomeItemsPerPage = 5
        this.growthTransactions = []
        this.growthTotalRecords = null
        this.growthPage = 1
        this.growthItemsPerPage = 5
        this.isLoadingGrowth = false
        this.isLoadingIncome = false
    },
    methods: {
        getPortfolioData () {
            this.$store.commit('isLoading')
            lenderService.getPortfolioData().then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    this.growthAccountValue = response.data.growthAmount
                    this.incomeAccountValue = response.data.incomeAmount
                }
            })
        },
        displayGrowth () {
            if (this.growthAccountValue !== null) {
                this.displayGrowthTrans = !this.displayGrowthTrans
                if (this.displayGrowthTrans === true) {
                    this.getGrowthData()
                }
            }
        },
        displayIncome () {
            if (this.incomeAccountValue !== null) {
                this.displayIncomeTrans = !this.displayIncomeTrans
                if (this.displayIncomeTrans === true) {
                    this.getIncomeData()
                }
            }
        },
        getIncomeData () {
            if (this.incomeTotalRecords !== this.incomeTransactions.length) {
                this.isLoadingIncome = true
                const query = 'itemsPerPage=' + this.incomeItemsPerPage + '&page=' + this.incomePage
                lenderService.getIncomeTransactionData(query).then((response) => {
                    if (response.status === 200) {
                        this.$store.commit('isNotLoading')
                        this.isLoadingIncome = false
                        this.incomeTransactions = response.data.incomeData
                        this.incomeTotalRecords = response.data.totalCount.totalRecords
                    }
                })
            } else {
                this.$store.commit('isNotLoading')
            }
        },
        getGrowthData () {
            if (this.growthTotalRecords !== this.growthTransactions.length) {
                this.isLoadingGrowth = true
                const query = 'itemsPerPage=' + this.growthItemsPerPage + '&page=' + this.growthPage
                lenderService.getGrowthTransactionData(query).then((response) => {
                    if (response.status === 200) {
                        this.$store.commit('isNotLoading')
                        this.isLoadingGrowth = false
                        this.growthTransactions = response.data.growthData
                        this.growthTotalRecords = response.data.totalRecords
                    }
                })
            } else {
                this.$store.commit('isNotLoading')
            }
        },
        loadMoreIncome (e) {
            var { scrollTop, clientHeight, scrollHeight } = e.target
            this.scrolling.scrollTop = scrollTop
            this.scrolling.clientHeight = clientHeight
            this.scrolling.scrollHeight = scrollHeight
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                this.incomePage += 1
                this.getIncomeData()
            }
        },
        loadMoreGrowth (e) {
            var { scrollTop, clientHeight, scrollHeight } = e.target
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                this.growthPage += 1
                this.getGrowthData()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

    .loaderContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .noCursor {
        cursor: unset !important;
    }
    .transactionAmount {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 0px;
        font-size: 16px;
        font-weight: 500;
        color: #4f4f4f
    }
    .fundDate {
        font-size: 12px;
        text-transform: capitalize;
        color: #8c8c8c;
        margin-bottom: 0px;
    }
    .description {
        font-weight: 600;
        font-size: 16px;
        color: #232323;
        text-transform: capitalize;
        margin-bottom: 2px;
    }
    .risk-container {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .incomeTransContainer {
        display: flex;
        flex-direction: row;
        padding: 6px;
        padding-bottom: 12px;
        padding-right: 28px;
    }
    .incomeWhole {
        overflow: scroll !important;
        max-height: 250px;
        min-height: 0px !important;
        flex-grow: 1;
        white-space: nowrap;
    }
    .incomeWhole::-webkit-scrollbar {
        width: 0 !important
    }
    ::v-deep .primary {
        background-color: #002fa7 !important;
        border-color: #002fa7 !important;
    }
    ::v-deep .v-pagination__item {
        height: 25px;
        min-width: 25px;
        font-size: 14px;
    }
    ::v-deep .v-pagination__navigation {
        height: 25px;
        width: 25px
    }
    ::v-deep .v-icon.v-icon {
        font-size: 14px;
    }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        color: #6a6a6a;
        font-size: 13px
    }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        height: 38px;
        font-size: 13px
    }
    ::v-deep .v-data-table-header {
        background-color: #f6f6f6;
    }
    .pagination {
        padding-top: 20px;
    }
    ::v-deep .v-pagination {
      justify-content: flex-end;
    }
    ::v-deep .v-chip__content {
        font-size: 13px;
        display: flex;
        justify-content: center;
    }
    .v-chip.v-size--default {
        border-radius: 8px
    }
    .v-chip {
        display: inline-block;
    }
    .main-container-content-nonEmptyState {
        min-height: 0px;
        width: 68%;
        display: block;
    }
    .nonEmptyStateGrowth {
        min-height: 56px;
        cursor: pointer;
        background: #F2F6FF;
        width: 100%;
        height: auto;
        padding: 10px;
        display: flex;
        flex-direction: row;
    }
    .values-container {
        display: flex;
        justify-content: flex-end;
    }
    .images-container {
        display: flex;
        justify-content: flex-start;
        width: 100%;
    }
    .referralLinkText {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        font-weight: 600;
        font-size: 18px;
        color: #4F4F4F;
        margin-bottom: 0px;
    }
    #growthImage {
        margin-right: 5px;
        height: auto;
        width: 22px;
    }
    .bannerIcons {
        color: #4F4F4F;
        cursor: pointer;
        margin-right: 10px;
        font-size: 22px !important;
    }
    .transactionIcons {
        color: #00C292;
        margin-right: 10px;
        font-size: 21px !important;
    }
    .transactionIconsWithdrawal {
        color: #C20000;
        margin-right: 10px;
        font-size: 21px !important;
    }
    .growth-account-value {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-right: 5px;
        margin-bottom: 0px;
        font-weight: 700;
        font-size: 18px;
        color: #232323;
        width: max-content;
    }

    .escrow-value {
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-right: 5px;
        margin-bottom: 0px;
        font-weight: 700;
        font-size: 18px;
        color: #232323;
        width: max-content;
    }

    @media (max-width: 1200px) {
        .main-container-content-nonEmptyState {
            width: 65%;
        }
        .nonEmptyState {
            padding: 9px;
        }
        .referralLinkText {
            font-size: 15px;
        }
        .growth-account-value {
            font-size: 15px;
        }
        .escrow-value {
            font-size: 15px;
        }
    }
    @media (max-width:768px){
        .main-container-content-nonEmptyState {
            width: 85%;
        }
        .nonEmptyStateGrowth {
            padding: 9px;
        }
        .referralLinkText {
            font-size: 14px;
        }
        .growth-account-value {
            font-size: 14px;
        }
        .escrow-value {
            font-size: 14px;
        }
    }
    @media (max-width: 480px) {
        .main-container-content-nonEmptyState {
            width: 100%;
        }
        .nonEmptyStateGrowth {
            padding: 8px;
        }
        .referralLinkText {
            font-size: 15px;
        }
        .growth-account-value {
            font-size: 15px;
        }
        .escrow-value {
            font-size: 15px;
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
            font-size: 11px
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
            font-size: 11px
        }
        ::v-deep .v-chip__content {
            font-size: 11px;
        }
        .bannerIcons {
            font-size: 19px !important;
        }
        #growthImage {
            width: 19px;
        }
        .transactionAmount {
            font-size: 13px;
        }
        .fundDate {
            font-size: 11px;
        }
        .description {
            font-size: 13px;
        }
        .transactionIcons {
            font-size: 18px !important;
        }
    }
</style>
